/**
 * @generated SignedSource<<70733e6dbe55e96de6efbf294beafca7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AcceptTermsInput = {
  termsVersion: string;
};
export type LandingPageView_ViewerAcceptsTermsVersionMutation$variables = {
  input: AcceptTermsInput;
};
export type LandingPageView_ViewerAcceptsTermsVersionMutation$data = {
  readonly AcceptTerms: {
    readonly acceptedTermsVersion: string | null;
  };
};
export type LandingPageView_ViewerAcceptsTermsVersionMutation = {
  response: LandingPageView_ViewerAcceptsTermsVersionMutation$data;
  variables: LandingPageView_ViewerAcceptsTermsVersionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "acceptedTermsVersion",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LandingPageView_ViewerAcceptsTermsVersionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserProfileViewer",
        "kind": "LinkedField",
        "name": "AcceptTerms",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LandingPageView_ViewerAcceptsTermsVersionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserProfileViewer",
        "kind": "LinkedField",
        "name": "AcceptTerms",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a72c5c5df7990e2723d1972470f40160",
    "id": null,
    "metadata": {},
    "name": "LandingPageView_ViewerAcceptsTermsVersionMutation",
    "operationKind": "mutation",
    "text": "mutation LandingPageView_ViewerAcceptsTermsVersionMutation(\n  $input: AcceptTermsInput!\n) {\n  AcceptTerms(input: $input) {\n    acceptedTermsVersion\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "14b70a415adaa17e5ae4eddf351fbc5a";

export default node;
